<div class="row">
    <div class="col">
        <select [(ngModel)]="selectedValue" (change)="handleSelection(selectedValue)">
            <option *ngFor="let item of dropDownList" [ngValue]="item">{{item.GetDescription()}}
            </option>
        </select>
    </div>
</div>